import {
  useLogin,
  useForgotPassword,
  useResetPassword,
  useRegister,
  useUsers,
  useDeleteUser,
  useUpdateUser,
} from "./auth";
import {
  useService,
  useUpdateService,
  useAddService,
  useDeleteService,
} from "./service";
import {
  useProduct,
  useUpdateProduct,
  useAddProduct,
  useDeleteProduct,
} from "./product";
import {
  useProductFeature,
  useUpdateProductFeature,
  useAddProductFeature,
  useDeleteProductFeature,
} from "./productFeature";
import {
  useCarousel,
  useUpdateCarousel,
  useAddCarousel,
  useDeleteCarousel,
} from "./carousel";
import { useTeam, useUpdateTeam, useAddTeam, useDeleteTeam } from "./team";
import {
  useTestimony,
  useUpdateTestimony,
  useAddTestimony,
  useDeleteTestimony,
} from "./testimony";
import {
  useComment,
  useUpdateComment,
  useAddComment,
  useDeleteComment,
} from "./comment";
import {
  useCategory,
  useAddCategory,
  useDeleteCategory,
  useUpdateCategory,
} from "./category";
import { useFastTrack, useDeleteFastTrack } from "./fasttrack";
import {
  useMetrics,
  useAddMetric,
  useDeleteMetric,
  useUpdateMetric,
} from "./metrics";

export const hooks = {
  useLogin,
  useService,
  useUpdateService,
  useForgotPassword,
  useResetPassword,
  useRegister,
  useCategory,
  useAddCategory,
  useDeleteCategory,
  useUpdateCategory,
  useAddService,
  useDeleteService,
  useUsers,
  useDeleteUser,
  useUpdateUser,
  useComment,
  useUpdateComment,
  useAddComment,
  useDeleteComment,
  useTeam,
  useUpdateTeam,
  useAddTeam,
  useDeleteTeam,
  useProduct,
  useUpdateProduct,
  useAddProduct,
  useDeleteProduct,
  useProductFeature,
  useUpdateProductFeature,
  useAddProductFeature,
  useDeleteProductFeature,
  useTestimony,
  useUpdateTestimony,
  useAddTestimony,
  useDeleteTestimony,
  useCarousel,
  useUpdateCarousel,
  useAddCarousel,
  useDeleteCarousel,
  useFastTrack,
  useDeleteFastTrack,
  useMetrics,
  useAddMetric,
  useDeleteMetric,
  useUpdateMetric,
};
